import api from "../storeApi";
import { createAsyncActionWithMeta } from "../../../../../libraries/packages/redux-utils/src/request/action";

export const bugReportCreateAction = createAsyncActionWithMeta(
  "bugReport_bugReportCreateAction_REQUEST",
  "bugReport_bugReportCreateAction_SUCCESS",
  "bugReport_bugReportCreateAction_FAILURE"
)<Parameters<typeof api.bugReport.methods.create>, any, Error>();
